import { convertirFechaFirebase, parsearParaContenidoEnriquecido } from "../utiles_objetos";

export class objetoChatGlobal{
    constructor({
            id = "",
            fecha = "",
            mensaje = {},
            asesor = "",
            isAdmin = "",
        } = {}) {

            this.id = id;
            this.fecha = fecha;
            this.mensaje = mensaje;
            this.asesor = asesor;
            this.isAdmin = isAdmin;
    }

    static fromJson(json){

        const fechaLocal = convertirFechaFirebase(json['fecha']);

        return new objetoChatGlobal({
            id: json['id'] || '',
            fecha: fechaLocal,
            mensaje: json['mensaje'] || '',
            asesor: json['asesor'] || '',
            isAdmin: json['isAdmin'] || false,
        });

    }

     toMap(){

    }

}
export const formMensajeInicial = {
    id : "",
    fecha : "",
    mensaje : {},
    asesor : "",
    isAdmin : "",
}